import React from 'react'
import Title from '../layouts/Title'
import { book, ecom, a4, fertify, event, scrape, zamxpress } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="View My Projects And Give Feedback"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
      
        <ProjectsCard
          title="Event Collab"
          des="Built a Flutter-based event management platform with role-based access control among organizers, attendees, sponsors, vendors, and volunteers. Integrated AI-powered event recommendations for attendees, AI-generated event descriptions to help organizers create high-quality listings quickly, and an AI chatbot addressing modern needs for personalization, automation, and real-time stakeholder collaboration."
          src={event}
          githubLink="https://github.com/aimaarif/Event-Collab"
          liveLink=""
        />
        <ProjectsCard
          title="Web Scraping Automation Suite"
          des="Developed a collection of specialized web scraping scripts to automate data collection from multiple real estate, auction, and business listing platforms. These tools extract and process structured information such as property details, company profiles, jewelry business data, car auction listings, and realtor contact verification."
          src={scrape}
          githubLink="https://github.com/aimaarif/Web-Scraping-Scripts"
          liveLink=""
        />
        <ProjectsCard
          title="Student Societies Management Platform"
          des="Built a web platform for student societies to manage meetings, memberships, and competitions. Designed and implemented a centralized student participation database.  Enabled online event registration and success story sharing to boost engagement. Collaborated in a team of 3 members from concept to deployment."
          src={ecom}
          githubLink=""
          liveLink="https://stouaf.com/"
        />
        
        
        <ProjectsCard
          title="Fertify Consultants"
          des="Developed a structured blog platform with category-based navigation for agricultural content. Implemented a user-friendly CMS for content creation and management. Delivered a responsive, SEO-optimized, and scalable architecture."
          src={fertify}
          githubLink="https://github.com/aimaarif/Fertify-Consultants"
          liveLink="https://fertifyconsultants.com"
        />
        <ProjectsCard
          title="Zam Express"
          des="Built and deployed a logistics web platform for Zam Express, implementing a structured frontend architecture with reusable components and optimized layouts. Focused on usability, performance, and clarity of information to effectively present international shipping services, transparent pricing, freight options, and customer support for a global user base."
          src={zamxpress}
          githubLink="https://github.com/aimaarif/Zam-Express"
          liveLink="https://zamxpress.com"
        />
        <ProjectsCard
          title="A4 Studio"
          des="This art gallery is a social platform, built with Django, offers a curated collection of artworks organized into various themes. Users can browse, explore, download and add them to their wishlist, and leave reviews. The platform also allows users to create profiles upload their own artwork and interact with other users.
          "
          src={a4}
          githubLink="https://www.github.com/aimaarif/A4-STUDIO"
          liveLink=""
        />
      </div>
    </section>
  );
}

export default Projects